import { Component, Input } from '@angular/core';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-notre-organisme-read-mode',
  templateUrl: './notre-organisme-read-mode.component.html',
  styleUrls: ['./notre-organisme-read-mode.component.scss'],
})
export class NotreOrganismeReadModeComponent {
  @Input() organisme!: Report.Organisme;
  @Input() organismePhoto!: string | undefined;
  @Input() organismeLogo!: string | undefined;
}
